const nsp = 'product/';
export const SET_PRODUCTS = `${nsp}SET_PRODUCTS`;
export const SET_NEW_PRODUCT = `${nsp}SET_NEW_PRODUCT`;
export const SET_UPDATED_PRODUCT = `${nsp}SET_UPDATED_PRODUCT`;
export const SET_PRODUCT_CATEGORIES = `${nsp}SET_PRODUCT_CATEGORIES`;
